import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '../../store/actions';
import * as TYPES from '../../store/actions/actions';
import { useNavigate } from 'react-router-dom';
import './style.sass';
import { Button, Col, Modal, Overlay, Row, Form } from 'react-bootstrap';
import { Images } from '../../components';
import QuizPagination from '../../components/QuizPagination';
import QuizOption from '../../components/QuizOption';
import { toast } from 'react-toastify';
import Countdown, { zeroPad } from 'react-countdown';
import ReactTooltip from 'react-tooltip';
import { MathJax, MathJaxContext } from 'better-react-mathjax';
import { BeatLoader } from 'react-spinners';
import DashedSegments from '../../components/DashedSegments';
import MarkIcon from '../../components/MarkIcon';
import Triangle from '../../components/Triangle';
import Arrow from '../../components/Arrow';
import requestElementFullscreen from '../../common/utils';
import DraggableContainer from '../../components/DraggableContainer';
import mathImg1 from '../../assets/img/math/1.svg';
import mathImg2 from '../../assets/img/math/2.svg';
import mathImg3 from '../../assets/img/math/3.svg';
import mathImg4 from '../../assets/img/math/4.svg';
import mathImg5 from '../../assets/img/math/5.svg';
import mathImg6 from '../../assets/img/math/6.svg';
import mathImg7 from '../../assets/img/math/7.svg';
import mathImg8 from '../../assets/img/math/8.svg';
import mathImg9 from '../../assets/img/math/9.svg';
import mathImg10 from '../../assets/img/math/10.svg';
import mathImg11 from '../../assets/img/math/11.svg';
import calcIcon from '../../assets/img/math/calc.jpg';
import { API, graphqlOperation } from 'aws-amplify';
import { listQuestionLinks, listQuestionLinksBySectionId } from '../../api/queries';
import { sortByOrderId } from '../../common';

const Quiz = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const uriQuestionIndex = Number(
    window.location.hash
      .substring(1)
      .substring(window.location.hash.substring(1).indexOf('question-') + 9) || 1,
  );

  const [paginationShow, setPaginationShow] = useState(false);
  const [draggableShow, setDraggableShow] = useState(false);
  const [calculatorShow, setCalculatorShow] = useState(false);
  const [forceFinishShow, setForceFinishShow] = useState(false);
  const [lastQuestionSubmitted, setLastQuestionSubmitted] = useState(false);
  const [modalShow, setModalShow] = useState(uriQuestionIndex === 1);
  const sectionRef = useRef(null);
  const target = useRef(null);
  const forceFinishTarget = useRef(null);
  const questionStartTimeRef = useRef(Date.now());

  const [user, setUser] = useState({});
  const [allQuestionBySectionID, setAllQuestionBySectionID] = useState([]);
  const [crossOutInfo, setCrossOutInfo] = useState([]);
  const [showCrossOut, setShowCrossOut] = useState(false);
  const [currentQuestionNumber, setCurrentQuestionNumber] = useState(null);
  const [occupancyChecked, setOccupancyChecked] = useState(null);
  const [answerSubmission, setAnswerSubmission] = useState([]);
  const [selectedQuiz, setSelectedQuiz] = useState({});
  const [submittedQuizData, setSubmittedQuizData] = useState([]);
  const [quizDuration, setQuizDuration] = useState(0);
  const [tempHours, setTempHours] = useState(0);
  const [tempMinutes, setTempMinutes] = useState(0);
  const [tempSeconds, setTempSeconds] = useState(0);
  const [flagArray, setFlagArray] = useState([]);
  const [questionCount, setQuestionCount] = useState(0);
  const [userQuizScore, setUserQuizScore] = useState(null);
  const [selectedQuizSectionId, setSelectedQuizSectionId] = useState(null);
  const [selectedSection, setSelectedSection] = useState({});
  const [totalAnswerSubmittedBySection, setTotalAnswerSubmittedBySection] = useState(0);
  const [contentLayout, setContentLayout] = useState('center');
  const [passageCallback, setPassageCallback] = useState('');
  const [sectionStartedAt, setSectionStartedAt] = useState(null);
  const [sectionTime, setSectionTime] = useState(0);
  const [submittedQuizDataForPagination, setSubmittedQuizDataForPagination] = useState([]);
  const [tempTimer, setTempTimer] = useState(0);
  const [isPassageLoading, setIsPassageLoading] = useState(false);
  const [isInWhiteList, setIsInWhiteList] = useState(false);
  const [isSectionLoading, setIsSectionLoading] = useState(false);
  const [shouldAutoOpenPagination, setShouldAutoOpenPagination] = useState(false);
  const autoPaginationTimerRef = useRef(null);
  const choiceShuffleMapRef = useRef({});

  const [
    currentUser,
    allQuestionListTemp,
    selectedQuizTemp,
    submittedQuizDataTemp,
    tempSelectedSectionId,
    tempUserQuizScore,
    tempGetUserQuizForStartedAt,
    quizReloadRequired,
    currentSelectedSection,
  ] = useSelector((state) => {
    return [
      state.auth.cognito,
      state.quiz.listQuestionsBySectionId,
      state.quiz.selectedQuiz,
      state.quiz.listUserQuizAnswers,
      state.finishUserQuiz.listQuestionsBySectionId,
      state.finishUserQuiz.quizFinishedData,
      state.quiz.getUserQuizForStartedAt,
      state.helper.quizReloadRequired,
      state.finishUserQuiz.currentSection,
    ];
  });

  const [mathInputValue, setMathInputValue] = useState('');
  const prevSelectedSectionIdRef = useRef(null);
  const prevSelectedQuizIdRef = useRef(null);

  const ANSWER_LABELS = ['A', 'B', 'C', 'D', 'E', 'F'];
  const shouldShuffleChoicesRaw =
    selectedQuizTemp?.quiz?.shouldShuffle ??
    selectedQuizTemp?.shouldShuffle ??
    selectedQuiz?.quiz?.shouldShuffle ??
    selectedQuiz?.shouldShuffle;
  const shouldShuffleChoices = shouldShuffleChoicesRaw === true || shouldShuffleChoicesRaw === 'true';

  const hashStringToUint32 = (input) => {
    let hash = 2166136261;
    for (let i = 0; i < input.length; i++) {
      hash ^= input.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
  };

  const mulberry32 = (seed) => {
    let t = seed >>> 0;
    return () => {
      t += 0x6d2b79f5;
      let x = t;
      x = Math.imul(x ^ (x >>> 15), x | 1);
      x ^= x + Math.imul(x ^ (x >>> 7), x | 61);
      return ((x ^ (x >>> 14)) >>> 0) / 4294967296;
    };
  };

  const getChoiceShuffleForQuestion = (question) => {
    if (!shouldShuffleChoices) return null;
    const qid = question?.id;
    if (!qid) return null;
    if (question?.answer?.answerType !== 'SINGLE_CORRECT') return null;
    const choices = question?.answer?.choices || [];
    const availableOriginalIndices = [];
    for (let i = 0; i < choices.length; i++) {
      if ((choices[i] || '').trim() !== '') {
        availableOriginalIndices.push(i);
      }
    }
    if (availableOriginalIndices.length <= 1) return null;
    const cacheKey = `${qid}:${availableOriginalIndices.length}`;
    const cached = choiceShuffleMapRef.current[cacheKey];
    if (cached) return cached;
    const seed = hashStringToUint32(cacheKey);
    const rand = mulberry32(seed);
    const shuffled = [...availableOriginalIndices];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(rand() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    const originalToDisplayIndex = {};
    shuffled.forEach((originalIndex, displayIndex) => {
      originalToDisplayIndex[originalIndex] = displayIndex;
    });
    const mapping = { displayToOriginalIndex: shuffled, originalToDisplayIndex };
    choiceShuffleMapRef.current[cacheKey] = mapping;
    return mapping;
  };

  const mapDisplayAnswerToOriginalAnswer = (question, displayAnswer) => {
    const exact = (displayAnswer || '').trim();
    if (!exact || exact === 'Skip') return exact;
    if (question?.answer?.answerType !== 'SINGLE_CORRECT') return exact;
    const mapping = getChoiceShuffleForQuestion(question);
    if (!mapping) return exact;
    const displayIndex = ANSWER_LABELS.indexOf(exact);
    if (displayIndex < 0) return exact;
    const originalIndex = mapping.displayToOriginalIndex[displayIndex];
    return ANSWER_LABELS[originalIndex] || exact;
  };

  const mapOriginalAnswerToDisplayAnswer = (question, originalAnswer) => {
    const exact = (originalAnswer || '').trim();
    if (!exact || exact === 'Skip') return exact;
    if (question?.answer?.answerType !== 'SINGLE_CORRECT') return exact;
    const mapping = getChoiceShuffleForQuestion(question);
    if (!mapping) return exact;
    const originalIndex = ANSWER_LABELS.indexOf(exact);
    if (originalIndex < 0) return exact;
    const displayIndex = mapping.originalToDisplayIndex[originalIndex];
    return ANSWER_LABELS[displayIndex] || exact;
  };

  const resetQuizViewState = () => {
    setPaginationShow(false);
    setDraggableShow(false);
    setCalculatorShow(false);
    setForceFinishShow(false);
    setLastQuestionSubmitted(false);
    setShouldAutoOpenPagination(false);
    if (autoPaginationTimerRef.current) {
      clearTimeout(autoPaginationTimerRef.current);
      autoPaginationTimerRef.current = null;
    }
    choiceShuffleMapRef.current = {};
    setAllQuestionBySectionID([]);
    setCrossOutInfo([]);
    setShowCrossOut(false);
    setOccupancyChecked(null);
    setMathInputValue('');
    setAnswerSubmission([]);
    setSubmittedQuizData([]);
    setSubmittedQuizDataForPagination([]);
    setTotalAnswerSubmittedBySection(0);
    setFlagArray([]);
    setQuestionCount(0);
    setSectionStartedAt(null);
    setSectionTime(0);
    setQuizDuration(0);
    setTempTimer(0);
    setTempHours(0);
    setTempMinutes(0);
    setTempSeconds(0);
    setPassageCallback('');
    setSelectedSection({});
    setIsPassageLoading(false);
    dispatch(Actions.saveQuestionsBySectionID([]));
    dispatch(Actions.saveListQuizAnswer([]));
    dispatch(Actions.saveGetUserQuizForStartedAt({}));
  };

  const checkDevEnvironment = () => {
    const url = window.location.href;
    const devKeywords = ['dev', 'localhost', '127.0.0.1'];

    return devKeywords.some((keyword) => url.includes(keyword));
  };

  const isValidSPRInput = (input) => {
    if (input === '' || input === '-') return true;

    const pattern = /^-?(\d*(\.\d*)?|\d+\/\d*)$/;

    if (!pattern.test(input)) {
      return false;
    }

    const digits = input.replace(/[^0-9]/g, '');
    return digits.length <= 6;
  };

  const handleMathInputChange = (event) => {
    event.stopPropagation();
    const { value } = event.target;
    if (isValidSPRInput(value)) {
      setMathInputValue(value);
    }
  };
  useEffect(() => {
    positionStickyElement();
    console.log('tempSelectedSectionId, ', tempSelectedSectionId);
    console.log('currentSelectedSection, ', currentSelectedSection);

    function positionStickyElement() {
      const container = sectionRef.current;
      const stickyElement = container.querySelector('.arrow_wrapper');

      const topOffset = container.scrollTop + 8;

      stickyElement.style.top = `${topOffset}px`;
    }

    const container = sectionRef.current;

    window.addEventListener('resize', positionStickyElement);
    container.addEventListener('scroll', positionStickyElement);

    return () => {
      window.removeEventListener('resize', positionStickyElement);
      container.removeEventListener('scroll', positionStickyElement);
    };
  }, [sectionRef]);

  useEffect(() => {
    if (uriQuestionIndex) {
      setCurrentQuestionNumber(uriQuestionIndex || 1);
    }
  }, [uriQuestionIndex]);

  useEffect(() => {
    if (tempSelectedSectionId) {
      if (prevSelectedSectionIdRef.current !== tempSelectedSectionId) {
        prevSelectedSectionIdRef.current = tempSelectedSectionId;
        setCurrentQuestionNumber(1);
        resetQuizViewState();
      }
      const questionData = {
        id: tempSelectedSectionId,
      };
      setSelectedQuizSectionId(tempSelectedSectionId);
      let obj = selectedQuizTemp?.quiz?.sections?.items?.find((o) => o.id === tempSelectedSectionId);
      dispatch(Actions.dispatchGetUserQuizForStartedAt({ id: selectedQuizTemp?.id }));
      setSelectedSection(obj);
      setSectionTime(obj?.time || 0);
      if (currentSelectedSection?.questionType !== 'Link') {
        setIsSectionLoading(true);
        dispatch(Actions.dispatchListQuestionsBySectionId(questionData)).finally(() => {
          setIsSectionLoading(false);
        });
      } else {
        setIsSectionLoading(true);
        API.graphql(
          graphqlOperation(listQuestionLinksBySectionId, {
            sectionId: tempSelectedSectionId,
            limit: 1000,
            sortDirection: 'ASC',
          }),
        ).catch(() => {
          return API.graphql(
            graphqlOperation(listQuestionLinks, {
              limit: 1000,
              filter: {
                sectionId: {
                  eq: tempSelectedSectionId,
                },
              },
            }),
          );
        }).then((result) => {
          console.log('list question links result : ', result);
          const items =
            result?.data?.listQuestionLinksBySectionId?.items || result?.data?.listQuestionLinks?.items || [];
          const questionList = items.map((link) => {
            const qb = link?.questionBank || {};
            const rawOrderId =
              link?.orderId != null ? link.orderId : qb?.orderId != null ? qb.orderId : null;
            const orderId = Number.isFinite(Number(rawOrderId)) ? Number(rawOrderId) : 999999;
            return {
              ...qb,
              linkId: link?.id,
              questionBankId: link?.questionBankId,
              sectionId: link?.sectionId,
              quizId: link?.quizId,
              orderId,
            };
          });
          sortByOrderId(questionList).then((sorted) => {
            dispatch(Actions.saveQuestionsBySectionID(sorted));
            setIsSectionLoading(false);
          });
          // setTimeout(() => {
          //   navigate('/question-banks');
          // }, 1500);
        });
      }
    }
  }, [tempSelectedSectionId, currentSelectedSection, dispatch]);

  useEffect(() => {
    if (tempGetUserQuizForStartedAt && tempSelectedSectionId) {
      let obj = tempGetUserQuizForStartedAt?.sections?.find((o) => o.id === tempSelectedSectionId);
      setSectionStartedAt(obj?.startedAt);
    }
  }, [tempGetUserQuizForStartedAt, tempSelectedSectionId]);

  useEffect(() => {
    if (sectionStartedAt && sectionTime > 0) {
      setQuizDuration(new Date(sectionStartedAt).getTime() + sectionTime * 60000);
    }
  }, [sectionStartedAt, sectionTime]);

  useEffect(() => {
    if (quizDuration) {
      setTempTimer(new Date(quizDuration).getTime());
    }
  }, [quizDuration]);

  useEffect(() => {
    if (tempUserQuizScore) {
      setUserQuizScore(tempUserQuizScore);
    }
  }, [tempUserQuizScore]);

  useEffect(() => {
    const whiteListOfShowingCopyIDButton = ['258176571@qq.com', 'sherilyn@beecadvantage.com'];
    // const whiteListOfShowingCopyIDButton = [];
    if (currentUser) {
      setUser(currentUser);
      if (
        currentUser?.email &&
        whiteListOfShowingCopyIDButton.find((email) => {
          return email === currentUser?.email;
        })
      ) {
        setIsInWhiteList(true);
      }
    }
  }, [currentUser]);

  useEffect(() => {
    if (currentQuestionNumber) {
      questionStartTimeRef.current = Date.now();
      setIsPassageLoading(true);
      const index = submittedQuizData.findIndex((object) => {
        return object.questionId === allQuestionBySectionID[currentQuestionNumber - 1]?.id;
      });
      if (index !== -1) {
        console.log('submittedQuizData[index]?.answer, ', submittedQuizData[index]?.answer);
        const currentQuestion = allQuestionBySectionID[currentQuestionNumber - 1];
        setOccupancyChecked(
          mapOriginalAnswerToDisplayAnswer(currentQuestion, submittedQuizData[index]?.answer),
        );
        if (allQuestionBySectionID[currentQuestionNumber - 1]?.answer?.answerType === 'SPR') {
          setMathInputValue(submittedQuizData[index]?.answer);
        }
      } else {
        console.log('submittedQuizData[index]?.answer, null ');
        setMathInputValue('');
        setOccupancyChecked(null);
      }
    }
    setPassageCallback(new Date().getTime());
    setTimeout(() => {
      var doc = [];
      doc = document.getElementsByClassName('line-ref');
      var inputList = Array.prototype.slice.call(doc);
      inputList?.map((item) => {
        try {
          var result = item.innerText.substring(6, item.innerText.length - 1);
          const getLine = document.getElementById(`${result}_start`).nextSibling;
          item.innerHTML = `<a data-tip="${getLine.textContent}" onclick="onLineRefClicked('${result}_start_highlight')" href="#${result}_start">line</a>`;
          document.getElementById(
            `${result}_start`,
          ).innerHTML = `<span id="${result}_start_highlight">${getLine.textContent}</span>`;
          document.getElementById(`${result}_start`).nextSibling.remove();
        } catch (err) {
          console.log('Error in line ref', err);
        }
      });
      setIsPassageLoading(false);
      ReactTooltip.rebuild();
    }, 800);
  }, [currentQuestionNumber, allQuestionBySectionID]);

  useEffect(() => {
    if (selectedQuizTemp) {
      if (prevSelectedQuizIdRef.current !== selectedQuizTemp?.id) {
        prevSelectedQuizIdRef.current = selectedQuizTemp?.id;
      }
      setSelectedQuiz(selectedQuizTemp);
      // setQuizDuration(Date.now() + selectedQuizTemp?.quiz?.time * 60000);
      // setPreviousAnswerTime(Date.now() + selectedQuizTemp?.quiz?.time * 60000);
      dispatch(Actions.dispatchListUserQuizAnswers({ id: selectedQuizTemp.id }));
    }
  }, [selectedQuizTemp, dispatch]);

  useEffect(() => {
    if (!submittedQuizDataTemp) return;

    const filterSubmittedAnswersForSection = submittedQuizDataTemp.filter(
      (x) => x.sectionId === selectedQuizSectionId,
    );

    setTotalAnswerSubmittedBySection(filterSubmittedAnswersForSection.length);
  }, [submittedQuizDataTemp, selectedQuizSectionId, allQuestionBySectionID.length]);

  useEffect(() => {
    if (!submittedQuizDataTemp) return;

    setSubmittedQuizData(submittedQuizDataTemp);
    dispatch(Actions.reRenderQuizPagination(new Date().getTime().toString()));

    const currentQuestionId = allQuestionBySectionID[currentQuestionNumber - 1]?.id;
    if (!currentQuestionId) return;

    const index = submittedQuizDataTemp.findIndex((object) => {
      return object.questionId === currentQuestionId;
    });
    if (index > -1) {
      console.log('on submittedQuizDataTemp, ', submittedQuizDataTemp[index]?.answer);
      const currentQuestion = allQuestionBySectionID[currentQuestionNumber - 1];
      setOccupancyChecked(
        mapOriginalAnswerToDisplayAnswer(currentQuestion, submittedQuizDataTemp[index]?.answer),
      );
    }
  }, [submittedQuizDataTemp, allQuestionBySectionID, currentQuestionNumber, dispatch]);

  useEffect(() => {
    if (allQuestionListTemp) {
      setAllQuestionBySectionID(allQuestionListTemp);
      if (allQuestionListTemp.length > 0) {
        setFlagArray(Array(allQuestionListTemp?.length).fill(false));
      }
    }
  }, [allQuestionListTemp]);

  useEffect(() => {
    const arr = new Array(allQuestionBySectionID.length).fill(null);
    const arrMap = arr.map(() => {
      return {
        A: false,
        B: false,
        C: false,
        D: false,
      };
    });
    setCrossOutInfo(arrMap);
  }, [allQuestionBySectionID]);

  const toggleContentLayout = (layout = 'right') => {
    if (contentLayout !== 'center') {
      setContentLayout('center');
    } else {
      setContentLayout(layout);
    }
  };

  const getQuestionElapsedSeconds = () => {
    const elapsed = Math.round((Date.now() - questionStartTimeRef.current) / 1000);
    return elapsed > 0 ? elapsed : 0;
  };

  // user selected quiz answer all data
  const saveQuizAnswer = (currentAnswer) => {
    const currentQuestion = allQuestionBySectionID[currentQuestionNumber - 1];
    const answerToSubmit =
      currentQuestion?.answer?.answerType === 'SINGLE_CORRECT'
        ? mapDisplayAnswerToOriginalAnswer(currentQuestion, currentAnswer)
        : currentAnswer;
    setAnswerSubmission({
      answer: answerToSubmit,
      questionId: allQuestionBySectionID[currentQuestionNumber - 1].id,
      userId: user.username,
      userQuizId: selectedQuizTemp?.id,
      quizId: allQuestionBySectionID[currentQuestionNumber - 1].quizId,
      time: getQuestionElapsedSeconds(),
      sectionId: selectedQuizSectionId,
    });
  };

  // answer: "A"
  // questionId: "fb9894a0-8a45-11ec-a9d6-0322e5b5b29e"
  // quizId: "8ed011d9-86be-4c95-bc6c-427c079552c6"
  // time: 60
  // userId: "67ee807c-2570-460c-950e-516d83f63d35"
  // userQuizId: "abba7a82-ae69-4115-aeaa-123468a0d0bb"

  // Button Actions
  const nextQuestion = () => {
    if (sectionRef.current) {
      sectionRef.current.scrollTop = 0;
    }
    dispatch(Actions.reRenderQuizPagination(new Date().getTime().toString()));
    if (currentQuestionNumber <= allQuestionBySectionID.length) {
      if (occupancyChecked !== '' && occupancyChecked !== null) {
        const questionId = allQuestionBySectionID[currentQuestionNumber - 1].id;
        const index = submittedQuizData.findIndex((object) => {
          return object?.questionId === questionId;
        });
        const currentQuestion = allQuestionBySectionID[currentQuestionNumber - 1];
        const answerToSubmit =
          currentQuestion?.answer?.answerType === 'SINGLE_CORRECT'
            ? mapDisplayAnswerToOriginalAnswer(currentQuestion, occupancyChecked)
            : occupancyChecked;
        var answerSubmissionPayload = {
          answer: answerToSubmit,
          questionId: questionId,
          userId: user.username,
          userQuizId: selectedQuizTemp?.id,
          quizId: allQuestionBySectionID[currentQuestionNumber - 1].quizId,
          time: getQuestionElapsedSeconds(),
          sectionId: selectedQuizSectionId,
        };
        if (index !== -1) {
          let listItems = [...submittedQuizData];
          let currentItem = { ...submittedQuizData[currentQuestionNumber - 1] };
          currentItem.answer = answerSubmissionPayload.answer;
          listItems[currentQuestionNumber - 1] = currentItem;
          //====================================SUBMISSION FOR PAGINATION====================================
          // const paginationSubmmitedAnswerIndex = submittedQuizDataForPagination.findIndex((object) => {
          //   return object?.questionId === questionId;
          // });
          // if(paginationSubmmitedAnswerIndex !== -1){
          //   var tempPaginationAnswer = submittedQuizDataForPagination;
          //   tempPaginationAnswer[paginationSubmmitedAnswerIndex].answer = answerSubmissionPayload.answer;
          //   setSubmittedQuizDataForPagination(tempPaginationAnswer);
          // }
          // dispatch(Actions.reRenderQuizPagination(new Date().getTime().toString()));
          //====================================SUBMISSION FOR PAGINATION====================================
          // setSubmittedQuizData(listItems);
          dispatch(Actions.dispatchUpdateUserQuizAnswer(answerSubmissionPayload));
        } else {
          var payload = answerSubmissionPayload;
          // setSubmittedQuizData([...submittedQuizData, payload]);
          //====================================SUBMISSION FOR PAGINATION====================================
          // const paginationSubmmitedAnswerIndex = submittedQuizDataForPagination.findIndex((object) => {
          //   return object?.questionId === questionId;
          // });
          // if(paginationSubmmitedAnswerIndex === -1){
          //   var tempPaginationAnswer = submittedQuizDataForPagination;
          //   tempPaginationAnswer.push({
          //     questionId: questionId,
          //     answer: answerSubmissionPayload.answer
          //   })
          //   setSubmittedQuizDataForPagination(tempPaginationAnswer);
          // }
          // dispatch(Actions.reRenderQuizPagination(new Date().getTime().toString()));
          //====================================SUBMISSION FOR PAGINATION====================================
          dispatch(Actions.dispatchCreateUserQuizAnswer(payload));
        }
        if (currentQuestionNumber < allQuestionBySectionID.length) {
          setTimeout(() => {
            window.location.href = `#question-${currentQuestionNumber + 1}`;
          }, 200);
          setCurrentQuestionNumber(currentQuestionNumber + 1);
          setMathInputValue('');
          const removeFill = Array.from(document.querySelectorAll('.answer_sheet .fill'));
          if (removeFill.length > 0) {
            removeFill.forEach((element) => {
              element.classList.remove('fill');
            });
          }
        } else {
          console.log('setLastQuestionSubmitted true ');
          setLastQuestionSubmitted(true);
        }
      }
    } else {
      dispatch(Actions.reRenderQuizPagination(new Date().getTime().toString()));
    }
  };

  const previousQuestion = () => {
    if (sectionRef.current) {
      sectionRef.current.scrollTop = 0;
    }
    if (currentQuestionNumber > 1) {
      window.location.href = `#question-${currentQuestionNumber - 1}`;
      setCurrentQuestionNumber(currentQuestionNumber - 1);
    }
  };

  const skipQuestion = () => {
    if (sectionRef.current) {
      sectionRef.current.scrollTop = 0;
    }
    if (currentQuestionNumber <= allQuestionBySectionID.length) {
      const questionId = allQuestionBySectionID[currentQuestionNumber - 1].id;
      const index = submittedQuizData.findIndex((object) => {
        return object?.questionId === questionId;
      });
      var answerSubmissionPayload = {
        answer: 'Skip',
        questionId: questionId,
        userId: user.username,
        userQuizId: selectedQuizTemp?.id,
        quizId: allQuestionBySectionID[currentQuestionNumber - 1].quizId,
        time: getQuestionElapsedSeconds(),
        sectionId: selectedQuizSectionId,
      };
      if (index !== -1) {
        let listItems = [...submittedQuizData];
        let currentItem = { ...submittedQuizData[currentQuestionNumber - 1] };
        currentItem.answer = answerSubmissionPayload.answer;
        listItems[currentQuestionNumber - 1] = currentItem;
        // setSubmittedQuizData(listItems);
        //====================================SUBMISSION FOR PAGINATION====================================
        // const paginationSubmmitedAnswerIndex = submittedQuizDataForPagination.findIndex((object) => {
        //   return object?.questionId === questionId;
        // });
        // if(paginationSubmmitedAnswerIndex !== -1){
        //   var tempPaginationAnswer = submittedQuizDataForPagination;
        //   tempPaginationAnswer[paginationSubmmitedAnswerIndex].answer = answerSubmissionPayload.answer;
        //   setSubmittedQuizDataForPagination(tempPaginationAnswer);
        // }
        //====================================SUBMISSION FOR PAGINATION====================================
        dispatch(Actions.dispatchUpdateUserQuizAnswer(answerSubmissionPayload));
      } else {
        var payload = answerSubmissionPayload;
        //====================================SUBMISSION FOR PAGINATION====================================
        //  const paginationSubmmitedAnswerIndex = submittedQuizDataForPagination.findIndex((object) => {
        //   return object?.questionId === answerSubmissionPayload.questionId;
        // });
        // if(paginationSubmmitedAnswerIndex === -1){
        //   var tempPaginationAnswer = submittedQuizDataForPagination;
        //   tempPaginationAnswer.push({
        //     questionId: answerSubmissionPayload.questionId,
        //     answer: "Skip"
        //   })
        //   setSubmittedQuizDataForPagination(tempPaginationAnswer);
        // }
        //====================================SUBMISSION FOR PAGINATION====================================
        // setSubmittedQuizData([...submittedQuizData, payload]);
        dispatch(Actions.dispatchCreateUserQuizAnswer(payload));
      }
      if (currentQuestionNumber < allQuestionBySectionID.length) {
        setCurrentQuestionNumber(currentQuestionNumber + 1);
        window.location.href = `#question-${currentQuestionNumber + 1}`;
        console.log('on skip question, ');
        setOccupancyChecked(null);
      }
    }
  };

  const flagQuestion = () => {
    if (sectionRef.current) {
      sectionRef.current.scrollTop = 0;
    }
    dispatch(Actions.reRenderQuizPagination(new Date().getTime().toString()));
    // 1. Make a shallow copy of the array
    let temp_state = [...flagArray];
    // 2. Make a shallow copy of the element you want to mutate
    let temp_element = { ...temp_state[currentQuestionNumber - 1] };
    // 3. Update the property you're interested in
    temp_element = !temp_state[currentQuestionNumber - 1];

    // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
    temp_state[currentQuestionNumber - 1] = temp_element;

    // 5. Set the state to our new copy
    setFlagArray(temp_state);
    // skipQuestion();
    setQuestionCount(questionCount + 1);
  };

  // finish quiz function
  const finishQuiz = () => {
    const userData = {
      id: tempSelectedSectionId,
      quizId: userQuizScore?.quizId,
      userQuizId: userQuizScore?.id,
      userId: userQuizScore?.userId,
      status: 'FINISHED',
    };
    dispatch(Actions.dispatchUpdateUserQuizSection(userData)).then((response) => {
      // const parsed = JSON.parse(response?.data?.updateUserQuiz);
      // if (parsed.statusCode === 200) {
      dispatch(Actions.saveListQuizAnswer([]));
      // navigate("/dashboard");
      dispatch(Actions.dispatchGetQuizScores(userQuizScore?.id)).then((userScoreResponse) => {
        setOccupancyChecked(null);
        const totalSections = userScoreResponse?.data?.getUserQuiz?.sections?.length;
        var finishedSections = 0;
        userScoreResponse?.data?.getUserQuiz?.sections.map((item) => {
          if (item.status === 'FINISHED') {
            finishedSections++;
          }
        });
        if (totalSections === finishedSections) {
          const updateQuizPayload = {
            id: userQuizScore?.id,
            userId: userQuizScore?.userId,
            status: 'FINISHED',
          };
          dispatch({
            type: TYPES.UI_START_LOADING,
          });
          dispatch(Actions.dispatchUpdateUserQuiz(updateQuizPayload)).then((response) => {
            navigate('/dashboard');
          });
        } else {
          navigate('/start_test');
        }
      });
    });
  };

  const changeOccupancyChecked = (val) => {
    const exactVal = (val || '').trim();
    console.log('changeOccupancyChecked, val: "', val, '"');
    setOccupancyChecked(exactVal);
    toggleCrossoutItem(exactVal, false);
  };

  const toggleCrossoutItem = (option, val, noEffect) => {
    const tempCrossOutInfo = crossOutInfo.concat();
    tempCrossOutInfo[currentQuestionNumber - 1][option] = val;
    setCrossOutInfo(tempCrossOutInfo);
    if (!noEffect && val && option === occupancyChecked?.trim()) {
      setOccupancyChecked(null);
    }
  };

  const countdownTimer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      if (!quizReloadRequired) {
        setTimeout(() => {
          toast.error('Time is up');
          navigate('/start_test');
        }, 2000);
      }
    }
    setTempHours(hours);
    setTempMinutes(minutes);
    setTempSeconds(seconds);
    const totalMinutes = hours * 60 + tempMinutes;
    return (
      <p className="questionLabel mb-0">
        {zeroPad(totalMinutes)}:{zeroPad(tempSeconds)}
      </p>
    );
  };

  const renderQuestion = (count) => {
    setQuestionCount(count);
  };

  useEffect(() => {
    setOccupancyChecked(mathInputValue || null);
  }, [mathInputValue]);

  const beginQuizFromModal = ($event) => {
    if ($event && typeof $event.stopPropagation === 'function') {
      $event.stopPropagation();
    }
    setModalShow(false);
    questionStartTimeRef.current = Date.now();
    setShouldAutoOpenPagination(true);
  };

  useEffect(() => {
    if (!shouldAutoOpenPagination) return;
    if (isSectionLoading) return;
    if (!allQuestionBySectionID || allQuestionBySectionID.length === 0) return;
    setPaginationShow(true);
    if (autoPaginationTimerRef.current) {
      clearTimeout(autoPaginationTimerRef.current);
    }
    autoPaginationTimerRef.current = setTimeout(() => {
      setPaginationShow(false);
      autoPaginationTimerRef.current = null;
    }, 3000);
    setShouldAutoOpenPagination(false);
  }, [shouldAutoOpenPagination, isSectionLoading, allQuestionBySectionID]);

  return (
    <div
      className={'quiz-view'}
      onClick={() => {
        setPaginationShow(false);
        setForceFinishShow(false);
      }}
    >
      {isSectionLoading ? (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(255,255,255,0.6)',
            zIndex: 1040,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <BeatLoader color={'#10A0DE'} size={18} loading={true} />
        </div>
      ) : null}
      <div className={'row menu-bar'}>
        <div className={'col-md-5'}>
          <div className={'first-item'}>
            {selectedQuiz?.quiz?.alias ? selectedQuiz?.quiz?.alias : selectedQuiz?.quiz?.title} -{' '}
            {selectedSection?.title} Section
          </div>
          <div className={'first-item'}>
            <span>{selectedSection?.questions?.items?.length} Questions</span>
            <Button variant="link" onClick={() => setModalShow(true)}>
              Directions
            </Button>
          </div>
        </div>
        <div className={'col-md-2'}>
          {quizDuration > 0 && (
            <div className={'timer'}>
              <div className={'time'}>
                {' '}
                <Countdown date={quizDuration} renderer={countdownTimer} key={tempTimer} />
              </div>
              <div className={'label'}>Time Left</div>
            </div>
          )}
        </div>
        <div
          className={'col-md-5'}
          style={{ display: 'flex', flexDirection: 'row-reverse', alignItems: 'center' }}
        >
          <div className="right-action">
            <img
              alt="fullScreen"
              onClick={() => {
                let element = document.documentElement;
                requestElementFullscreen(element);
              }}
              src={Images.expandImage}
            />
          </div>
          {selectedQuiz?.quiz?.type !== 'HSPT' && (
            <>
              <div style={{ marginLeft: 12 }}>
                <Button
                  variant="info"
                  onClick={(e) => {
                    setDraggableShow(!draggableShow);
                    setCalculatorShow(false);
                    e.stopPropagation();
                  }}
                >
                  <div class="squared">
                    X<sup>2</sup>
                  </div>
                  <div style={{ fontSize: 14 }}>Reference</div>
                </Button>
              </div>
              <div>
                <Button
                  variant="info"
                  onClick={(e) => {
                    setDraggableShow(false);
                    setCalculatorShow(!calculatorShow);
                    e.stopPropagation();
                  }}
                  style={{ padding: '3px 14px' }}
                >
                  <div>
                    <img src={calcIcon} alt="calculator" style={{ width: 12, height: 16 }} />
                  </div>
                  <div style={{ fontSize: 14 }}>Calculator</div>
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
      <DashedSegments />
      <div className={'container'}>
        <Row className={'question-div'}>
          {selectedSection?.title === 'Reading' && isPassageLoading && (
            <>
              <div className="text-center">
                <BeatLoader color={'#10A0DE'} size={30} loading={isPassageLoading} />
              </div>
            </>
          )}
          <Col
            md={contentLayout === 'center' ? 6 : 7}
            className={
              selectedSection?.title !== 'Reading'
                ? 'scenario'
                : isPassageLoading
                ? 'scenario d-none'
                : 'scenario'
            }
            ref={sectionRef}
          >
            {allQuestionBySectionID[currentQuestionNumber - 1]?.passage?.direction == null &&
            allQuestionBySectionID[currentQuestionNumber - 1]?.passage?.attribution == null &&
            allQuestionBySectionID[currentQuestionNumber - 1]?.passage?.body == null ? (
              <>
                {/* If no passage/direction/attribution */}
                <div className={'question mt-5'}>
                  {allQuestionBySectionID[currentQuestionNumber - 1]?.title?.includes('<math') ? (
                    <>
                      {/* Show MATHJAX */}
                      <MathJaxContext>
                        <MathJax>
                          <div
                            className={'question-description'}
                            dangerouslySetInnerHTML={{
                              __html: allQuestionBySectionID[currentQuestionNumber - 1]?.title,
                            }}
                          ></div>
                        </MathJax>
                      </MathJaxContext>
                    </>
                  ) : (
                    <>
                      {/* Show Question title in place of passage */}
                      <div
                        className={'question-description'}
                        dangerouslySetInnerHTML={{
                          __html: allQuestionBySectionID[currentQuestionNumber - 1]?.title,
                        }}
                      ></div>
                    </>
                  )}
                </div>
              </>
            ) : (
              <>
                {checkDevEnvironment() && isInWhiteList && (
                  <Button
                    style={{ marginLeft: '20px' }}
                    onClick={() => {
                      navigator.clipboard
                        .writeText(allQuestionBySectionID[currentQuestionNumber - 1]?.passage?.id)
                        .then(function () {
                          // 提示用户内容已复制
                          toast.success(
                            `Passage ID ${
                              allQuestionBySectionID[currentQuestionNumber - 1]?.passage?.id
                            } copied to clipboard`,
                          );
                        })
                        .catch(function (err) {
                          console.error('Could not copy text: ', err);
                        });
                    }}
                  >
                    Copy passageId
                  </Button>
                )}
                {allQuestionBySectionID[currentQuestionNumber - 1]?.passage?.direction ? (
                  <>
                    <div
                      className={'title'}
                      dangerouslySetInnerHTML={{
                        __html:
                          allQuestionBySectionID[currentQuestionNumber - 1]?.passage?.direction,
                      }}
                    />
                  </>
                ) : null}

                {allQuestionBySectionID[currentQuestionNumber - 1]?.passage?.attribution ? (
                  <div
                    className={'description'}
                    dangerouslySetInnerHTML={{
                      __html:
                        allQuestionBySectionID[currentQuestionNumber - 1]?.passage?.attribution,
                    }}
                  />
                ) : null}
                {allQuestionBySectionID[currentQuestionNumber - 1]?.passage?.body ? (
                  <>
                    <div
                      className={'description'}
                      // ref={sectionRef}
                      key={passageCallback}
                      dangerouslySetInnerHTML={{
                        __html: allQuestionBySectionID[currentQuestionNumber - 1]?.passage?.body,
                      }}
                    />
                  </>
                ) : null}
              </>
            )}
            <Arrow
              direction={`${contentLayout === 'center' ? 'topRight' : 'bottomLeft'}`}
              onClick={() => {
                toggleContentLayout('right');
              }}
            />
          </Col>
          <Col
            md={contentLayout === 'center' ? 6 : 5}
            className={
              selectedSection?.title !== 'Reading'
                ? 'question_side'
                : isPassageLoading
                ? 'question_side d-none'
                : 'question_side'
            }
          >
            <div className="question_wrapper">
              <div className={'question'}>
                <div className={'question-no'}>{currentQuestionNumber}.</div>
                <div className={'flag-question'}>
                  <span
                    onClick={() => {
                      flagQuestion();
                    }}
                  >
                    {/* <TbFlag className={'flag-icon'} /> */}
                    <MarkIcon marked={flagArray[currentQuestionNumber - 1]} />
                    <span className={'flag-label'}>Flag This Question For Review</span>
                  </span>
                  {/* <textarea id="question_id_to_copy" style={{ position: 'fixed', left: '-1000px' }}>
                    {allQuestionBySectionID[currentQuestionNumber - 1].id}
                  </textarea> */}
                  {checkDevEnvironment() && isInWhiteList && (
                    <Button
                      style={{ marginLeft: '20px' }}
                      onClick={() => {
                        navigator.clipboard
                          .writeText(allQuestionBySectionID[currentQuestionNumber - 1].id)
                          .then(function () {
                            // 提示用户内容已复制
                            toast.success(
                              `Question ID ${
                                allQuestionBySectionID[currentQuestionNumber - 1].id
                              } copied to clipboard`,
                            );
                          })
                          .catch(function (err) {
                            console.error('Could not copy text: ', err);
                          });
                      }}
                    >
                      Copy QuestionID
                    </Button>
                  )}
                </div>
                {allQuestionBySectionID[currentQuestionNumber - 1]?.answer?.answerType ===
                  'SINGLE_CORRECT' && (
                  <Button
                    variant={showCrossOut ? 'primary' : 'secondary'}
                    className={showCrossOut ? 'crossout-on crossout-switch' : 'crossout-switch'}
                    onClick={() => {
                      setShowCrossOut(!showCrossOut);
                    }}
                  >
                    ABC
                  </Button>
                )}
              </div>
              <DashedSegments />
              {(allQuestionBySectionID[currentQuestionNumber - 1]?.passage?.direction != null ||
                allQuestionBySectionID[currentQuestionNumber - 1]?.passage?.attribution != null ||
                allQuestionBySectionID[currentQuestionNumber - 1]?.passage?.body != null) &&
                (allQuestionBySectionID[currentQuestionNumber - 1]?.title?.includes('<math') ? (
                  <>
                    <MathJaxContext>
                      <MathJax>
                        <div
                          className={'question-description'}
                          dangerouslySetInnerHTML={{
                            __html: allQuestionBySectionID[currentQuestionNumber - 1]?.title,
                          }}
                        ></div>
                      </MathJax>
                    </MathJaxContext>
                  </>
                ) : (
                  <div
                    className={'question-description'}
                    dangerouslySetInnerHTML={{
                      __html: allQuestionBySectionID[currentQuestionNumber - 1]?.title,
                    }}
                  ></div>
                ))}
              {allQuestionBySectionID[currentQuestionNumber - 1]?.mathTitle &&
                selectedSection?.title &&
                selectedSection?.title?.toLowerCase()?.includes('math') && (
                  <div
                    className={'question-description'}
                    dangerouslySetInnerHTML={{
                      __html: allQuestionBySectionID[currentQuestionNumber - 1]?.mathTitle,
                    }}
                  ></div>
                )}
            </div>
            <div className={'options'}>
              {allQuestionBySectionID[currentQuestionNumber - 1]?.answer?.answerType ===
              'SINGLE_CORRECT' ? (
                <>
                  {(() => {
                    const currentQuestion = allQuestionBySectionID[currentQuestionNumber - 1];
                    const choices = currentQuestion?.answer?.choices || [];
                    const availableOriginalIndices = [];
                    for (let i = 0; i < choices.length; i++) {
                      if ((choices[i] || '').trim() !== '') {
                        availableOriginalIndices.push(i);
                      }
                    }
                    const mapping = getChoiceShuffleForQuestion(currentQuestion);
                    const displayToOriginalIndex = mapping
                      ? mapping.displayToOriginalIndex
                      : availableOriginalIndices;
                    return displayToOriginalIndex.map((originalIndex, displayIndex) => {
                      const displayLabel = ANSWER_LABELS[displayIndex];
                      if (!displayLabel) return null;
                      return (
                        <div
                          className="option-wrapper"
                          key={`${currentQuestion?.id || 'question'}-${displayLabel}`}
                        >
                          <QuizOption
                            name={'question_option'}
                            crossed={
                              showCrossOut && crossOutInfo[currentQuestionNumber - 1]?.[displayLabel]
                            }
                            label={displayLabel}
                            value={choices[originalIndex]}
                            changeChecked={changeOccupancyChecked}
                            saveQuizAnswer={saveQuizAnswer}
                            checked={occupancyChecked}
                          />
                          {showCrossOut &&
                            (!crossOutInfo[currentQuestionNumber - 1]?.[displayLabel] ? (
                              <div
                                className="option-crossout"
                                onClick={() => {
                                  toggleCrossoutItem(displayLabel, true);
                                }}
                              >
                                {displayLabel}
                              </div>
                            ) : (
                              <div
                                className="crossout-undo"
                                onClick={() => {
                                  toggleCrossoutItem(displayLabel, false);
                                }}
                              >
                                Undo
                              </div>
                            ))}
                        </div>
                      );
                    });
                  })()}
                </>
              ) : allQuestionBySectionID[currentQuestionNumber - 1]?.answer?.answerType ===
                'SPR' ? (
                <>
                  <div>
                    <Form
                      onSubmit={(event) => {
                        event.preventDefault();
                      }}
                    >
                      <Form.Group className="mb-3" controlId="formBasicMathEmail">
                        <Form.Label>Your Answer</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter your answer"
                          onChange={handleMathInputChange}
                          maxLength={6}
                          value={mathInputValue}
                        />
                        <Form.Text className="text-muted">
                          Accept numbers, [ - ], [ . ] or [ / ]
                          <div>Maximum input of 6 characters</div>
                          <div>
                            The input must be a valid number, and the leading zero before the
                            decimal point can be omitted.
                          </div>
                          <div>E.g., -.0088 and .0088 are both valid.</div>
                        </Form.Text>
                      </Form.Group>
                    </Form>
                  </div>
                  <div className="math_answer_wrapper">
                    <div>Answer preview:</div>
                    <span className="math_answer">
                      {(() => {
                        let displayValue = mathInputValue;
                        if (displayValue.startsWith('.')) {
                          displayValue = '0' + displayValue;
                        } else if (displayValue.startsWith('-.')) {
                          displayValue = '-0' + displayValue.slice(1);
                        }
                        if (displayValue.includes('/')) {
                          const parts = displayValue.split('/');
                          let sign = '';
                          let numerator = parts[0].trim();
                          let denominator = parts[1].trim();
                          if (numerator.startsWith('-')) {
                            sign = '-';
                            numerator = numerator.slice(1);
                          }
                          return (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              {sign && (
                                <div
                                  style={{
                                    marginRight: '5px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    height: '100%',
                                  }}
                                >
                                  {sign}
                                </div>
                              )}
                              <div
                                className="fraction"
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                }}
                              >
                                <div className="math_item">{numerator}</div>
                                <hr style={{ width: '100%', margin: '0' }} />
                                <div className="math_item">{denominator}</div>
                              </div>
                            </div>
                          );
                        } else {
                          return <div className="math_item">{displayValue}</div>;
                        }
                      })()}
                    </span>
                  </div>
                </>
              ) : null}
            </div>
          </Col>
        </Row>
      </div>
      <DashedSegments />
      <div className={'row menu-bar menu-bottom'}>
        <div className="col-md-5"></div>
        <div className="col-md-2">
          <Button
            style={{ position: 'relative', display: 'flex', alignItems: 'center' }}
            ref={target}
            variant="info"
            onClick={(e) => {
              setForceFinishShow(false);
              setPaginationShow(!paginationShow);
              e.stopPropagation();
            }}
          >
            <div>
              Question {currentQuestionNumber} of {allQuestionBySectionID?.length}
            </div>
            <Triangle isUp={!paginationShow} />
          </Button>
          <Overlay target={target.current} show={paginationShow} placement="top">
            {({ ...props }) => (
              <div
                {...props}
                style={{
                  position: 'absolute',
                  ...props.style,
                  width: '60%',
                  minWidth: '480px',
                  margin: '0 auto',
                  backgroundColor: 'transparent',
                  paddingBottom: '24px',
                }}
              >
                <div className="pagination_wrapper">
                  <div className={'first-item pagination_header'}>
                    {selectedQuiz?.quiz?.alias
                      ? selectedQuiz?.quiz?.alias
                      : selectedQuiz?.quiz?.title}{' '}
                    - {selectedSection?.title} Section
                  </div>
                  <div className={'second-item pagination_header'}>
                    <div className="page-item blue">x</div>
                    <div>Current</div>
                    <div className="page-item active-filled">x</div>
                    <div>Answered</div>
                    <div className="page-item red">x</div>
                    <div>Flaged</div>
                  </div>
                  <QuizPagination
                    withoutArray={false}
                    currentQuestion={currentQuestionNumber ? currentQuestionNumber : 0}
                    setCurrentQuestionNumber={setCurrentQuestionNumber}
                    questionLength={allQuestionBySectionID ? allQuestionBySectionID.length : 0}
                    allQuestionBySectionID={allQuestionBySectionID}
                    submittedQuizData={submittedQuizData}
                    nextQuestion={nextQuestion}
                    previousQuestion={previousQuestion}
                    setOccupancyChecked={setOccupancyChecked}
                    flagArray={flagArray}
                    questionCount={questionCount}
                    renderQuestion={renderQuestion}
                    submittedQuizDataForPagination={submittedQuizDataForPagination}
                  />
                </div>
              </div>
            )}
          </Overlay>
        </div>
        <div className="col-md-5">
          <div className={'last-item'}>
            <div className={'left-menu'}>
              <button
                className={'skip-btn'}
                onClick={() => {
                  setOccupancyChecked('Skip');
                  skipQuestion();
                }}
              >
                Skip
              </button>
              {typeof currentQuestionNumber !== 'undefined' && currentQuestionNumber !== 1 && (
                <button className={'skip-btn'} onClick={() => previousQuestion()}>
                  Previous
                </button>
              )}
              <button
                className={occupancyChecked ? 'next-btn' : 'pre-btn'}
                onClick={() => nextQuestion()}
              >
                Next
              </button>
              {allQuestionBySectionID.length !== totalAnswerSubmittedBySection &&
                lastQuestionSubmitted &&
                currentQuestionNumber === allQuestionBySectionID?.length && (
                  <>
                    <Button
                      className={'done-btn unfinished'}
                      onClick={(e) => {
                        setPaginationShow(false);
                        setForceFinishShow(!forceFinishShow);
                        e.stopPropagation();
                      }}
                      ref={forceFinishTarget}
                    >
                      Finish
                    </Button>
                    <Overlay
                      target={forceFinishTarget.current}
                      show={forceFinishShow}
                      placement="top"
                    >
                      {({ ...props }) => (
                        <div
                          {...props}
                          style={{
                            position: 'absolute',
                            right: 0,
                            ...props.style,
                            width: '60%',
                            minWidth: '480px',
                            margin: '0 auto',
                            backgroundColor: 'transparent',
                            paddingBottom: '24px',
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          <div className="pagination_wrapper">
                            <div className={'first-item pagination_header'}>
                              You haven't answered all the questions. Are you sure you want to
                              finish the test?
                            </div>
                            <div className={'second-item pagination_header'}>
                              <div className="page-item active-unfinished">x</div>
                              <div>Unanswered</div>
                            </div>
                            <div className={'second-item pagination_header'}>
                              <Button
                                className={'done-btn'}
                                onClick={() => {
                                  setForceFinishShow(false);
                                }}
                              >
                                Continue Answering
                              </Button>
                              <Button
                                className={'done-btn force-finish'}
                                onClick={() => {
                                  finishQuiz();
                                }}
                              >
                                Finish Anyway
                              </Button>
                            </div>
                            <QuizPagination
                              withoutArray={true}
                              currentQuestion={currentQuestionNumber ? currentQuestionNumber : 0}
                              setCurrentQuestionNumber={setCurrentQuestionNumber}
                              questionLength={
                                allQuestionBySectionID ? allQuestionBySectionID.length : 0
                              }
                              allQuestionBySectionID={allQuestionBySectionID}
                              submittedQuizData={submittedQuizData}
                              nextQuestion={nextQuestion}
                              previousQuestion={previousQuestion}
                              setOccupancyChecked={setOccupancyChecked}
                              flagArray={flagArray}
                              questionCount={questionCount}
                              renderQuestion={renderQuestion}
                              submittedQuizDataForPagination={submittedQuizDataForPagination}
                            />
                          </div>
                        </div>
                      )}
                    </Overlay>
                  </>
                )}
              {allQuestionBySectionID.length === totalAnswerSubmittedBySection && (
                <Button
                  className={'done-btn'}
                  onClick={() => {
                    finishQuiz();
                  }}
                >
                  Done
                </Button>
              )}
            </div>
            {/* {submittedQuizData.length === allQuestionBySectionID.length && ( */}
          </div>
        </div>
      </div>
      {draggableShow && (
        <DraggableContainer
          handleClose={() => {
            setDraggableShow(false);
          }}
        >
          <div class="formula-wrapper">
            <img src={mathImg1} alt="Geometric formula" />
            <img src={mathImg2} alt="Geometric formula" />
            <img src={mathImg3} alt="Geometric formula" />
            <img src={mathImg4} alt="Geometric formula" />
            <img src={mathImg5} alt="Geometric formula" />
            <img src={mathImg6} alt="Geometric formula" />
            <img src={mathImg7} alt="Geometric formula" />
            <img src={mathImg8} alt="Geometric formula" />
            <img src={mathImg9} alt="Geometric formula" />
            <img src={mathImg10} alt="Geometric formula" />
            <img src={mathImg11} alt="Geometric formula" />
          </div>
          <div>
            <div style={{ padding: '5px 20px' }}>
              The number of degrees of arc in a circle is 360.
            </div>
            <div style={{ padding: '5px 20px' }}>
              The number of radians of arc in a circle is 2π.
            </div>
            <div style={{ padding: '5px 20px' }}>
              The sum of the measures in degrees of the angles of a triangle is 180.
            </div>
          </div>
        </DraggableContainer>
      )}
      {calculatorShow && (
        <DraggableContainer
          handleClose={() => {
            setCalculatorShow(false);
          }}
        >
          <iframe
            src="https://www.desmos.com/testing/cb-digital-sat/graphing"
            width="600x"
            height="480px"
            style={{ border: 'none' }}
            title="Embedded Page"
          ></iframe>
        </DraggableContainer>
      )}
      <Modal
        show={modalShow}
        size="md"
        className={'quiz-modal'}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={beginQuizFromModal}
      >
        <Modal.Header closeButton>
          <Modal.Title className={'quiz-modal-heading'} id="contained-modal-title-vcenter">
            {selectedSection?.title} Test Directions
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p
            className={'quiz-modal-body'}
            dangerouslySetInnerHTML={{
              __html: selectedSection?.description,
            }}
          ></p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{ backgroundColor: '#49A250', borderColor: '#49A250' }}
            onClick={beginQuizFromModal}
          >
            Let’s do it!
          </Button>
        </Modal.Footer>
      </Modal>
      <ReactTooltip />
    </div>
  );
};

export default Quiz;
